.section__product {
  display: grid;
  position: relative;
  width: 100%;
  max-width: 1190px;
  margin-inline: auto;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 0 30px;
  grid-template-areas:
    "area1 area1 area1 area1 area1 area1 area1 area1 area1 area2 area2 area2 area2 area2 area2 area2";

  @media (min-width:768px) and (max-width:1189px) {
    gap: 0 20px;
  }
  h1 {
    font-family: var(--heading-font-family, 'sofia-pro, sans-serif');
    font-size: 30px;
    margin-bottom: 5px;
    margin-top: 10px;

    @media (max-width: 767px) {
      text-align: center;
      font-family: var(--heading-font-family, 'sofia-pro, sans-serif');
      font-size: 30px;
      font-weight: 600;
      line-height: 42px;
      margin-bottom: 5px;
      margin-top: 10px;
    }
  }
}

.section__product_left {
  grid-area: area1;
  max-height: 548px;
  position: sticky;
  top: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  overflow: hidden;
  @media (max-width: 767px) {
      position: static;
  }
}


.section__product_right {
  grid-area: area2;
  /* outline: 1px solid green; */
  @media (max-width: 767px) {
    margin-inline: 10px;
  }
}

.product_images {
  display: flex;
  gap: 5px;
  min-height: 548px;
  max-height: 548px;
  justify-content: space-between;
}

@keyframes productImageShimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@mixin product-image-shimmer {
  background-color: #c8c8c8;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.7) 50%, transparent 100%);
    transform: translateX(-100%);
    animation: productImageShimmer 1.5s ease-in-out infinite;
  }
}

.product_images_placeholder {
  display: flex;
  gap: 5px;
  width: 100%;
  max-height: 548px;
}

/* Invisible space reservation while LCP image preloads — no shimmer skeleton */
.product_images_loading {
  width: 100%;
  min-height: 548px;
  max-height: 548px;
  visibility: hidden;
  pointer-events: none;

  @media (max-width: 767px) {
    min-height: 418px;
    max-height: none;
  }
}

.product_images_placeholder_thumbs {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100px;
  flex-shrink: 0;

  @media (max-width: 767px) {
    flex-direction: row;
    width: 100%;
    overflow: hidden;
  }
}

.product_images_placeholder_thumb {
  width: 98px;
  height: 98px;
  border-radius: 4px;
  flex-shrink: 0;
  @include product-image-shimmer;

  @media (max-width: 767px) {
    width: 72px;
    height: 72px;
  }
}

.product_images_placeholder_main {
  flex: 1;
  min-height: 548px;
  border-radius: 4px;
  @include product-image-shimmer;
  overflow: hidden;

  .main_image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media (max-width: 767px) {
    width: 100%;
    min-height: 90vw;
    max-height: 455px;
  }
}

.skeleton_wrapper {
  display: contents;
}

.skeleton {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #e0e0e0;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    animation: productImageShimmer 1.5s infinite;
  }
}

.product_thumbs {
  width: 100px;
  overflow: hidden;
  margin: 0;
  [class*="slick-current"] img {
    border:3px solid #ED1B34 !important;
  }
}

.product_main_image {
  margin-left: 0;
  margin-right: 0;
  width: calc(100% - 110px);
  border-radius: 5px;
  overflow: hidden;
  /* outline: 1px solid red; */
}
@media (max-width: 767px) {
  .product_main_image {
    aspect-ratio: 548 / 548;
    max-height: 548px;
    width: 100%;
    height: auto;
  }
}

.main_image {
  aspect-ratio: 548 / 548;
  max-height: 548px;
  width: 548px;
  height: 548px;
  cursor: pointer;
}

.thumb_image {
  aspect-ratio: 1/1;
  max-height: 100px;
  width: 100%;
}

.product_review {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 10px;
  @media (max-width: 767px) {
    align-content: center;
    justify-content: center;
  }

  .product_stars {
    display: flex;
    flex-direction: row;
    gap: 3px;
  }
  .review_text {
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    @media (max-width: 767px) {
      font-size: 12px;
    }
  }
}



@media (max-width: 767px) {
  .section__product {
    display: flex;
    flex-direction: column;

  }
  .section__product_left {
    max-height: fit-content;
  }
  .product_thumbs {
    width: 100%;
    margin: 0 0 0 0;
  }
  .product_main_image {
    width: 100%;
  }
  .product_images {
    flex-direction: column;
    max-height: fit-content;
    min-height: 418px;
  }
  .product_thumbs {
    order: 2;
  }
  .main_image {
    max-height: fit-content;
    width: 100%;
    height: auto;
  }
  .thumb_image {
    aspect-ratio: 1/1;
    max-height: fit-content;
    width: 100%;
  }

}

.slide_video video {
  object-fit: cover;
  height: 100%;
  object-position: center;
}

.slide_item {
  position: relative;
}
.image_caption {
  position: absolute;
  z-index: 100;
}
.image_caption.top-left {
  left: 10px;
  top: 10px;
}
.image_caption.top-right {
  right: 10px;
  top: 60px;
}
.image_caption.bottom-left {
  left: 10px;
  bottom: 10px;
}
.image_caption.bottom-right {
  right: 10px;
  bottom: 10px;
}

.caption_line {
  padding: 3px 6px;
  background-color: red;
  color:#fff;
  background-color: var(--bg-color);
  color: var(--text-color);
  border-radius: 4px;
  margin-bottom: 10px;
  font-size: 0.7em;
}



.section__step_upsell {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 1);
  position: fixed;
  top: 0;
  left: 0;
  opacity: 1 !important;
  z-index: 10000000000;


}
.scs_upsell_modal {
  width: 100%;
  height: 100%;
  display: flex;
  background: #000 url("https://cdn.shopify.com/s/files/1/0732/5909/0212/files/bg-modal.jpg?v=1758698062") no-repeat bottom center;
  background-size: 390px;
  margin: auto;
  text-align: center;

}
.scs_upsell_modal_content {
  background-color: #fff;
  border-radius:40px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  padding: 40px 24px;
  width: 100%;
  max-width: 390px;
  margin: 0 auto auto auto;
  position: relative;
}
.scs_upsell_modal_inner {
  width: 100%;
}

.scs_upsell_close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.scs_upsell_modal_content {
  .offer_time {
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    color: #525151;
    border-radius: 5px;
    padding:5px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;

    border: 1px dashed #888787;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);
    margin-bottom: 20px;
  }
  h4 {
    margin-top:0;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 22px;
    font-weight: 600;
    text-align: center;
    color: #000;
    margin-bottom: 0;
    strong {
      font-weight: 900;
      font-size: 28px;
      display: block;
      span {
        color: #056906;
      }
    }
  }
  h5 {
    margin-top: 5px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 22px;
    font-weight: 900;;
    color: #DF0000;
  }
  .btn_no {
    display: flex;
    width: 160px;
    padding: 10px 25px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    border: 1px solid #6C6C6C;
    text-align: center;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 14px;
    font-style: normal;
    font-weight: 800;
    line-height: 150%; /* 27px */
    color: #6C6C6C;
    background-color: transparent;
  }
  .btn_yes {
    display: flex;
    width: 160px;
    padding: 10px 25px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    background: #056906;
    border: 0;
    color: var(--White, #FFF);
    text-align: center;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 14px;
    font-style: normal;
    font-weight: 800;
    line-height: 150%; /* 27px */
  }

  .btns {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 20px;
  }
}

.scs_upsell_offer {
  width: 100%;
  height: 100%;
  padding: 50px 10px 5px 10px;
  overflow-y: scroll;
  display: flex;
  background-color: #fff;
  z-index: 1;
  position: fixed;
  flex-direction: column;

  h4 {
    margin-top: 0;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 28px;
    font-weight: 900;
    text-align: center;
    color: #000;
    margin-bottom: 5px;

  }
  h6 {
    margin-top: 0;
    margin-bottom: 10px;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: #605F5F;
    line-height: 18px;
    margin-bottom: 15px;
    span {
      font-size: 16px;
      font-weight: 700;
      strong {
        color: #056906;
      }
    }
  }
}
.scs_upsell_offer {
  width: 100%;
  max-width: 390px;
  margin:0 auto;
  left: 50%;
  transform: translateX(-50%);
  opacity: 1;
  z-index: 10000000001;
}

@media (min-width: 768px) {
  .scs_upsell_modal_inner {
    max-width: 600px;
    margin: 0 auto auto auto;
  }
  .scs_upsell_modal {
    background-size: 768px;
    width: 760px;
    height: 760px;
    border-radius: 40px !important;
    overflow: hidden;
    position: relative;
    top: 50%;
    transform: translate(0,-50%);
    background: url("https://cdn.shopify.com/s/files/1/0732/5909/0212/files/bg-offer-desktop.jpg?v=1758885435") no-repeat bottom center;
    background-size: cover;
  }
  .scs_upsell_modal_content {
    border-top-left-radius: 40px !important;
    border-top-right-radius: 40px !important;
    max-width: 768px;
    overflow: hidden;
  }
  .scs_upsell_close {
    top:20px;
    right: 20px;
  }
  .scs_upsell_modal_content {
    .offer_time {
      max-width: 500px;
      margin-inline: auto;
    }
    .btns {
      max-width: 500px;
      margin-inline: auto;
      justify-content: space-evenly;
    }
  }
  .scs_upsell_offer {
    width: 760px;
    max-width: 760px;
    .scs_upsell_offer_inner {
      width: 500px;
      margin-inline: auto;
    }
  }
}
.section__product_wrapper {
  width: 100%;
  max-width: 1190px;
  margin-inline: auto;
  @media (min-width:768px) and (max-width:1189px) {
    margin-inline: 10px;
    width: calc(100% - 20px);
  }
}
.section__product_top {
  display: flex;
  margin-bottom: 30px;
  gap: 20px;
  min-height: 180px;
  align-items: start;
  [class^="_color_option"] {
    padding: 0;
    max-width: 150px;
    flex: 1;
  }
  @media (min-width:768px) and (max-width:1189px) {
    gap: 10px;
    min-height: 120px;
  }
  @media (max-width:767px) {
    min-height: 130px;
  }
  @media (max-width: 767px) {
    overflow-x: scroll;
    margin-bottom: 10px;
    gap: 5px;

    [class^="_color_option"] {
      flex-basis: 100px;
      flex-grow: 1;
      flex-shrink: 0;
      padding: 3px 3px 0 !important;
      [class^="_title"] {
        font-size: 12px;
      }
    }
  }
}
.scs_new_design_2026 {
  [data-step="1"] [id="step_2"], [data-step="1"] [id="step_3"] {
    opacity: 0.7;
    pointer-events: none;
  }
  .section__product_left {
    margin-top:0;
  }
  h1 {
    text-transform: uppercase !important;
    font-weight: 600;
    font-size: 32px;
    line-height: 100%;
    @media (max-width: 767px) {
      font-size: 22px;
    }
    @media (min-width:768px) and (max-width:991px) {
      font-size: 20px;
    }
  }
  .review_text {
    @media (min-width:768px) and (max-width:991px) {
      font-size: 10px;
    }
  }
  .pre_title {
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-weight: 500;
    font-size: 16px;
    line-height: 15px;
    @media (max-width: 767px) {
      text-align: center;
    }
    @media (min-width:768px) and (max-width:991px) {
      font-size: 14px;
    }

  }
  .price_wrapper {
    .price_text {
      font-family: var(--font-family, 'sofia-pro, sans-serif');
      font-weight: 400;
      font-size: 15px;
      line-height: 15px;
      color: #767676;
      @media (min-width:768px) and (max-width:991px) {
        font-size: 13px;
      }
    }
    .price {
      display: inline-block;
      vertical-align: middle;
      margin-left: 8px;
      font-family: var(--font-family, 'sofia-pro, sans-serif');
      font-weight: 700;
      font-size: 23.44px;
      line-height: 100%;
      color: #D61E2D;
      @media (min-width:768px) and (max-width:991px) {
        font-size: 18px;
      }
    }
    .compare_price {
      display: inline-block;
      vertical-align: middle;
      font-family: var(--font-family, 'sofia-pro, sans-serif');
      font-weight: 500;
      font-size: 18px;
      line-height: 100%;
      color: #000;

      s {
        text-decoration: line-through;
      }

      @media (min-width:768px) and (max-width:991px) {
        font-size: 15px;
      }
    }
    @media (max-width: 767px) {
      text-align: center;
    }
  }
  [id="default-vehicle-year"]:has( option[value=""]:checked ) {
    border: 2px solid #ED1B34;
  }
  .section__product_left {
    max-height: max-content;
  }
  .lifestyle_image {
    margin-top: 10px;
    @media (max-width: 767px) {
      display: none;
    }
    img {
      width: 100%;
     
    }
  }

  [class*="icon-with-text "] {
    display: flex !important;
    width: 100%;
    @media (max-width: 991px) {
      gap: 5px;
      padding: 3px 3px;
    }
    li[class="icon-with-text__item"] {
      @media (max-width: 991px) {
        gap: 3px;
      }
      img {
        @media (max-width: 991px) {
          width: 15px;
        }
      }
      span[class="h4"] {
        @media (max-width: 991px) {
          font-size: 10px !important;
          letter-spacing: -0.2px;
        }
      }
    }
  }

}

.callouts {
  padding: 5px 10px;
  background: #F2F2F2;
  display: inline-flex;
  gap: 10px;
  margin-top: 15px;
  .callout {
    display: flex;
    gap: 5px;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0.19px;
    text-align: center;
    vertical-align: middle;
    @media (max-width: 767px) {
      font-size: 14px;
    }
    img {
      width: 20px;
      height: 20px;
    }
  }
}